export class AlreadyExists extends Error {
  public constructor() {
    super()

    this.message = 'errors.alreadyExists'
  }
}
